import React from 'react';
import { CalendarEvent } from '../../types/ics';
import { formatDate } from '../../utils/dateUtils';

interface CalendarDayProps {
  date: Date;
  events: CalendarEvent[];
  isCurrentMonth: boolean;
  onEventClick: (event: CalendarEvent) => void;
}

export const CalendarDay: React.FC<CalendarDayProps> = ({
  date,
  events,
  isCurrentMonth,
  onEventClick,
}) => {
  const isToday = new Date().toDateString() === date.toDateString();
  
  return (
    <div
      className={`min-h-[120px] p-2 border-b border-r border-gray-200 ${
        !isCurrentMonth ? 'bg-gray-50' : ''
      }`}
    >
      <div className="flex items-center justify-center mb-1">
        <span
          className={`
            w-7 h-7 flex items-center justify-center rounded-full
            ${isToday ? 'bg-blue-500 text-white' : ''}
            ${!isCurrentMonth ? 'text-gray-400' : 'text-gray-700'}
          `}
        >
          {date.getDate()}
        </span>
      </div>
      
      <div className="space-y-1">
        {events.slice(0, 3).map((event) => (
          <button
            key={event.uid}
            onClick={() => onEventClick(event)}
            className="w-full text-left text-xs p-1 rounded bg-blue-100 text-blue-800 truncate hover:bg-blue-200 transition-colors"
            title={`${event.summary}\n${formatDate(event.startDate)}`}
          >
            {event.summary}
          </button>
        ))}
        {events.length > 3 && (
          <button
            onClick={() => onEventClick(events[3])}
            className="text-xs text-gray-500 hover:text-gray-700 transition-colors"
          >
            +{events.length - 3} more
          </button>
        )}
      </div>
    </div>
  );
};